import type { SVGProps } from 'react';

export function SkullIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18 18.427c2.194-1.65 3.6-4.185 3.6-7.027 0-4.969-4.298-9-9.6-9-5.303 0-9.6 4.031-9.6 9 0 2.842 1.406 5.377 3.6 7.027V19.8a1.8 1.8 0 0 0 1.8 1.8H9v-1.5c0-.499.401-.9.9-.9s.9.401.9.9v1.5h2.4v-1.5c0-.499.401-.9.9-.9s.9.401.9.9v1.5h1.2a1.8 1.8 0 0 0 1.8-1.8zM6 12c0-1.324 1.076-2.4 2.4-2.4s2.4 1.076 2.4 2.4-1.076 2.4-2.4 2.4A2.4 2.4 0 0 1 6 12m9.6-2.4c1.324 0 2.4 1.076 2.4 2.4s-1.076 2.4-2.4 2.4a2.4 2.4 0 0 1-2.4-2.4c0-1.324 1.076-2.4 2.4-2.4" />
    </svg>
  );
}
